import { IHttpClientRequestParameters } from "@/http/IHttpClientRequestParameters";
import { httpClient } from "@/http/HttpClient";
import InfraUrl from "@/models/InfraUrl";

export class LoginApi {
  async getRedirectUrl(customerId: string, username: string): Promise<string> {
    const getParameters: IHttpClientRequestParameters<any> = {
      url: "/redirect-url?customerId=" + customerId + "&username=" + username,
    };
    return httpClient.getUnauthenticated(getParameters);
  }

  async isSSOProviderRequest(): Promise<string> {
    const postParameters: IHttpClientRequestParameters<any> = {
      url: "/request/validate",
    };
    return httpClient.postUnauthenticated(postParameters);
  }

  async getInfraUrlsForClientIds(clientIds: string[]): Promise<InfraUrl[]> {
    return httpClient.getUnauthenticated({
      url: "/client/url?clientIds=" + clientIds,
    });
  }
}

export const loginApi = new LoginApi();
